export const translations = {
  en: {
    menu: "Menu",
    blogs: "Blogs",
    events: "Events",
    jobs: "Jobs",
    careers: "Careers",
    media: "Media",
    newsletter: "Newsletter",
    resources: "Resources",
    donate: "Donate",
    login: "Login",
    signUp: "Sign Up",
    myAccount: "My Account",
    savedSearches: "Saved Searches",
    recentSearches: "Recent Searches",
    bookmarks: "Bookmarks",
    settings: "Settings",
    admin: "Admin",
    logout: "Logout",
    about: "About",
    whatWeOffer: "What we offer",
    ourWork: "Our work",
    team: "Team",
    supporters: "Supporters",
    members: "Members",
    atAGlance: "At a glance",
    rcc: "Research Commissioning Centre",
    governance: "Governance",
    partners: "Partners",
    policies: "Institutional Policies and Reports",
    contactUs: "Contact Us",
    services: "Services",
    research: "Research",
    evidenceHub: "Evidence Hub",
    dep: "Development Evidence Portal",
    egm: "Evidence gap maps",
    eis: "Evidence impact summaries",
    isd: "Impact Stories Dashboard",
    jde: "Journal of Development Effectiveness",
    publications: "Publications",
    replication: "Replication Studies",
    impact: "Impact",
    termsOfUse: "Terms of use",
    privacyPolicy: "Privacy policy",
    copyright: "Copyright ©",
    allRightsReserved: "International Initiative for Impact Evaluation (3ie) | All rights reserved | ",
    aboutUsText: "We are a mission-driven non-profit organization dedicated to using evidence to transform people’s lives. We collaborate with governments, foundations, NGOs, development and research organizations across the globe.",
    exploreAboutUs: "Explore About us",
    whatWeOfferText: "We support governments and development partners to generate and use rigorous evidence that informs better policies, programs and investments. Our work spans the full decision-making cycle, helping identify what works, why it works, and how to improve outcomes.",
    exploreWhatWeOffer: "Explore What we offer",
    theoryOfChange: "Theory of change development",
    evidenceSynthesis: "Evidence Synthesis",
    impactEvalScoping: "Impact evaluations scoping and design",
    researchGrantsAdmin: "Research grants administration",
    impactEvaluation: "Impact evaluation",
    trainingInitiatives: "Training Initiatives",
    treHelpdesk: "Transparency, research and ethics helpdesk",
    ourWorkText: "Our diverse evidence to policy portfolio spans all major development sectors and regions and represents the scale and depth of 3ie's global programs and initiatives.",
    exploreOurWork: "Explore Our work",
    education: "Education",
    foodSystemsEgm: "Food Systems and Nutrition Evidence and Gap map",
    climateChange: "Mitigating and adapting to climate change",
    ruralIndiaLivelihoods: "Rural India Livelihoods Project",
    peacebuilding: "Peacebuilding",
    genderEmpowerment: "Gender and women’s empowerment",
    innovationsData: "Innovations in data for impact evaluation",
    wacie: "WACIE",
    globalEvidenceCommitment: "Global Evidence Commitment: Advancing Use of Rigorous Evidence",
    evidenceHubTextDesc: "We make high-quality development evidence publicly accessible through key databases, journals and repositories, which include studies produced by 3ie and beyond.",
    exploreEvidenceHub: "Explore Evidence Hub",
    welcomeTitle: "3ie Development Evidence Portal",
    welcomeDesc: "The Development Evidence Portal (DEP) is an expansive and growing repository of rigorous evidence on what works in international development. It contains high-quality impact evaluations, systematic reviews, and evidence gap maps and is the most comprehensive resource for this kind of evidence from low- and middle-income countries. We maintain this portal as a global public good and ensure it is updated frequently. We are committed to keeping it this way.",
    aboutDep: "About the DEP",
    seeWhatsNew: "See what's new",
    latestAnnouncement: "Latest announcement: ",
    ier: "impact evaluation records",
    srr: "systematic review records",
    evidenceText: "evidence",
    gapMaps: "gap maps",
    exploreBySector: "Explore by Sector",
    ourDonors: "Our Main Partners/Donors",
    popularSearches: "Popular Searches",
    moreEvidence: "More evidence from our work",
    mostRecentSearches: "Most Recent Searches",
    seeAll: "See All",
    noRecentSearches: "No recent searches data found.",
    noSavedSearches: "No saved searches data found.",
    previousSearches: "Previous Searches",
    noPreviousSearches: "No previous searches data found.",
    backToSearch: "Back to Search",
    publishedOn: "Published on",
    whatsNew: "What's New",
    back: "Back",
    decisionTree: "DEP Decision Tree",
    taxonomyExplorer: "Taxonomy explorer",
    backToEvidencePortal: "Back to evidence portal",
    taxonomyIntroPart1: "To make it easy to find relevant evidence 3ie has documented the interventions evaluated and the outcomes measured in thousands of studies in our evidence portal. These interventions and outcomes are organized into a hierarchical taxonomy. To find out more about the taxonomy click",
    here: "here",
    taxonomyIntroPart2: "Use the taxonomy explorer to identify the interventions/outcomes of interest to you, then use them to search or filter for studies",
    backOnThePortal: "back on the portal.",
    enterKeyword: "Please enter a keyword! ",
    checkInterventionOutcome: "Please check at least any one option from Intervention and Outcome! ",
    searchBtn: "Search",
    resetBtn: "Reset",
    interventionsCheckbox: "Interventions *",
    outcomesCheckbox: "Outcomes *",
    definitionsCheckbox: "Definitions (optional)",
    checkAsterisk: "Please check at least any one option from the fields marked with an asterisk (",
    interventionsLabel: "Interventions",
    outcomesLabel: "Outcomes",
    selectSectors: "Select sectors",
    searchPlaceholder: "Search",
    seeAllInterventions: "See all studies with this intervention",
    seeAllOutcomes: "See all studies with this outcome",
    backToTaxonomySearch: "Back to taxonomy search",
    searchResultsTitle: "Search results | 3ie",
    alertsSentToEmail: "Alerts will be sent to the email attached to your account.",
    createAccountToAlert: "Create an account to create a search alert",
    searchSaved: "This search has been saved.",
    createAccountToSave: "Create an account to save this search",
    bookmarkSaved: "This bookmark has been saved.",
    createAccountToBookmark: "Create an account to bookmark this record",
    bookmarkRemoved: "Bookmark removed successfully.",
    createAccountToDeleteBookmark: "Create an account to delete this bookmark record",
    okay: "Okay",
    success: "Success!",
    noResultsFor: "There are no results for ",
    hereAreSomeTips: "Here are some tips:",
    checkSpellingMistakes: "Check for spelling mistakes",
    reduceKeywords: "Reduce the number of keywords used or try a broader search phrase",
    tryAlternativeSearches: "Try alternative searches or suggested filters sections below",
    orMaybeWeCanHelp: "Or may be we can help",
    alternativeSearches: "Alternative Searches",
    noAlternativeSearches: "No alternative searches found",
    geographicInformation: "GEOGRAPHIC INFORMATION",
    districtName: "District name: ",
    stateProvinceName: "State/Province name: ",
    cityTown: "City/Town: ",
    keywords: "Keywords: ",
    expandSectorInfo: "Click to expand sector info",
    collapseSectorInfo: "Click to collapse sector info",
    projectName: "Project name: ",
    implementationAgency: "Implementation agency: ",
    programFundingAgency: "Program funding agency: ",
    researchFundingAgency: "Research funding agency: ",
    headlineFindings: "Headline findings",
    evidenceBase: "Evidence base",
    implicationsPolicyPractice: "Implications for policy and practice",
    implicationsFurtherResearch: "Implications for further research",
    mainFindings: "Main findings",
    grantholdingInstitution: "Grantholding institution",
    evidenceProgramme: "Evidence Programme",
    synopsis: "Synopsis",
    context: "Context",
    researchQuestions: "Research questions",
    methodologySummary: "Methodology summary",
    methodology: "Methodology",
    instancesEvidenceUse: "Instances of evidence use",
    background: "Background",
    researchObjectives: "Research objectives",
    findings: "Findings",
    qualityAssessment: "Quality assessment",
    fundedBy3ie: "Funded by 3ie",
    bookmark: "Bookmark",
    systematicReviews: "Systematic reviews",
    impactEvaluations: "Impact evaluations",
    status: "Status",
    countryUppercase: "COUNTRY",
    readMore: "Read More",
    printThisPage: "Print this page",
    goToMapUrl: "Go to map URL",
    goToPublicationUrl: "Go to publication URL",
    goToSource: "Go to source",
    lookForOpenVersion: "Look for open version",
    goToDataset: "Go to dataset",
    goToRegistration: "Go to registration",
    clearFilters: "Clear Filters",
    apply: "Apply",
    taxonomy: "Taxonomy",
    aboutTheRepository: "About the repository",
    oecdDacClassification: "OECD DAC sector classification",
    unSdg2030: "United Nations Sustainable Development Goals 2030",
    noFiltersFor: "No filters for ",
    of: "of",
    resultsLabel: "Results",
    similarSearches: "Similar searches:",
    systematicReviewsTag: "Systematic Reviews",
    impactEvaluationsTag: "Impact Evaluations",
    evidenceGapMapsTag: "Evidence Gap Maps",
    threeieFundingTag: "3ie Funding",
    otherFundingSourcesTag: "Other Funding Sources",
    yesTag: "Yes",
    noTag: "No",
    saveSearch: "Save Search",
    createNotification: "Create Notification",
    selectAllOnPage: "Select all on page:",
    selectAll: "Select All:",
    records: "records",
    resultsPerPage: "Results per page",
    mostRelevant: "Most Relevant",
    mostRecent: "Most Recent",
    mostPopular: "Most Popular",
    sortByLabel: "Sort by",
    notSureWhereToStart: "Not sure where to start? Try our",
    searchGuideNew: "NEW",
    searchGuidanceTool: "search guidance tool",
    advancedSearchTitle: "Advanced Search",
    taxonomyOf: "Taxonomy of",
    interventionsAndOutcomes: "interventions & outcomes",
    taxonomyTooltipText: "3ie has documented the interventions evaluated and the outcomes measured in thousands of studies in our evidence portal. These interventions and outcomes are organised into a hierarchical taxonomy to make it easy to find relevant evidence. Use the taxonomy explorer to identify the interventions/outcomes of interest to you, then use them to search or filter for studies on the portal.",
    addAnotherSection: "+ Add another section",
    clearBtn: "Clear",
    helpBtn: "Help",
    provideAdvancedSearchQuery: "Please provide advanced search query.",
    advFirstTimeDialogText: "First time using advanced search? This feature is very powerful but needs to be used in a specific way in order to return expected results. We encourage you to review the documentation by clicking the \"Help\" button below the search bar.",
    searchPhrasePlaceholder: "Search a phrase such as \"Cash transfers\"",
    aboutBtn: "About",
    orText: "Or",
    exploreAllRecordsUsingFilters: "explore all records using filters",
    selectOption: "Select option",
    impactEvaluationFilter: "Impact Evaluation",
    systematicReviewFilter: "Systematic Review",
    evidenceGapMapFilter: "Evidence Gap Map",
    sectorAgriculture: "Agriculture fishing and forestry",
    sectorEducation: "Education",
    sectorEnergy: "Energy and extractives",
    sectorFinance: "Financial sector",
    sectorHealth: "Health",
    sectorSocialProtection: "Social protection",
    sectorIndustryTrade: "Industry trade and services",
    sectorInformationCommunications: "Information and communications technologies",
    sectorPublicAdministration: "Public administration",
    sectorTransportation: "Transportation",
    sectorWaterSanitation: "Water sanitation and waste management",
    noteAboutFilters: "A note about using filters",
    filterNoteP1: "The filters on this site depend on the information we capture about each study, which we catalogue using a labour-intensive coding process. We plan to eventually code all information for every study, but resource limitations mean we sometimes cannot capture all information for every study right away. As a result, certain studies are missing some of the information used to drive the filters.",
    filterNoteP1Bold: "When you apply a filter, you may be filtering out studies that are of interest to you, but that have not yet been fully coded.",
    filterNoteP2: "All studies from 2016 and earlier have been fully coded, so you do not risk filtering out any pre-2017 studies. In addition, all studies have been coded for study type, sector, region, country, fragility & conflict, and publication year, so those filters will always retrieve all relevant studies. But applying other filters may leave out some recent studies.",
    filterNoteP3: "To ensure you are not filtering out studies of interest, you can rely on the basic search function, which will find all studies that contain your search terms in the title or abstract.",
    filterNoteP4: "You can help us keep the evidence portal up to date, with complete information for every study, by",
    makingADonation: "making a donation.",
    decisionDialogIntro: "The Development Evidence Portal contains a wealth of evidence about what works in global development. But finding what you need in an expansive database like DEP isn't always straightforward. To help you find the most useful evidence, we've created a tool that guides you through the process of searching the DEP, step by step.",
    exploreMore: "Explore More", surveyModalHeading: "Help us improve your experience!",
    surveyModalIntroText1: "Answer one quick question below or",
    surveyTakeFullSurvey: "take the full survey",
    surveyModalIntroText2: "to share more feedback.",
    otherLabel: "Other:",
    pleaseSpecify: "Please specify",
    closeButton: "Close",
    submitFeedbackButton: "Submit my feedback",
    dontShowAgain: "Don’t show this again",
    successModalHeading: "Thank you for your time and feedback!",
    successModalIntroTextSuccess: "We appreciate you taking a moment to share your feedback. Your responses will help us improve your experience on 3ie\"s Development Evidence Portal.",
    successModalIntroTextError: "We\"re sorry, but the survey could not be completed due to a technical issue. Please try again later.",
    fillOutCompleteSurvey: "Fill out the complete survey →",
    q1_question: "How useful is the DEP for your work, on a scale of 1 to 5?",
    q2_question: "Why are you looking for evidence today? I am looking to (Please select all that apply)",
    q2_opt1: "Search for studies to be included in a literature review/systematic review",
    q2_opt2: "Inform the design of an evaluation study",
    q2_opt3: "Gather insights useful to commission new research",
    q2_opt4: "Inform decisions about what programmes to implement or how to implement them",
    q2_opt5: "To inform a proposal",
    q3_question: "How often do you use the Development Evidence Portal?",
    q3_opt1: "Daily",
    q3_opt2: "Weekly",
    q3_opt3: "Monthly",
    q3_opt4: "Rarely",
    q3_opt5: "Using for the first time today",
    q4_question: "Which of these do you think would improve the usefulness and user experience of the DEP? (Please select all that apply)",
    q4_opt1: "Better search and filter capabilities",
    q4_opt2: "Chatbot to query study metadata (e.g., how many studies have been conducted in a particular country, how many studies have used a particular method, etc.)",
    q4_opt3: "Chatbot to query study results (e.g., what do studies say about the effectiveness of X intervention, etc.)",
    q4_opt4: "Interactive data visualizations/infographics about evidence for different sectors, regions, etc.",
    q4_opt5: "Mobile friendliness",
    q4_opt6: "Page performance (loading speed)",
    q4_opt7: "Search interface in other languages",
    q5_question: "What is your current institutional affiliation? Please select all that apply.",
    q5_opt1: "Government agency",
    q5_opt2: "Academic institution",
    q5_opt3: "Think tank and/or research institute",
    q5_opt4: "Evaluation association-national, regional or international",
    q5_opt5: "Multilateral organisation",
    q5_opt6: "NGO-international",
    q5_opt7: "NGO-national/local",
    q5_opt8: "Consulting firm",
    q5_opt9: "Donor agency",
    q5_opt10: "Media",
    filterYearOfPub: "Year of Publication",
    filterFcvStatus: "FRAGILITY AND CONFLICT",
    filterEvalMethod: "Evaluation Method",
    filterSectors: "Sectors",
    filterStudyType: "Study Type",
    filterFundedBy: "Funded by",
    filterDatasetAvail: "DATASET AVAILABLE",
    filterUnSdg: "UN GLOBAL GOALS",
    filterDacCodes: "OECD DAC CODES",
    filterEquityFocus: "Equity Focus",
    filterOutcomes: "OUTCOMES",
    filterRegion: "Region",
    filterEquityDim: "Equity Dimension",
    filterProducedBy3ie: "PRODUCED BY 3ie",
    filterCountry: "Country",
    filterThemes: "Themes",
    filterRegistration: "REGISTRATION",
    filterInterventions: "Interventions",
    advSearchTitle: "Title",
    advSearchAuthor: "Author",
    advSearchKeywords: "Keywords",
    advSearchAbstract: "Abstract",
    advSearchEvalDesign: "Evaluation design",
    advSearchEvalMethod: "Evaluation method",
    advSearchPubType: "Publication type",
    advSearchStudyType: "Study type",
    advSearchSector: "Sector",
    advSearchRegion: "Region",
    advSearchFundedBy: "Funded by",
    advSearchCountry: "Country",
    advSearchPrimaryTheme: "Primary theme",
    advSearchEquityFocus: "Equity focus",
    advSearchEquityDimension: "Equity dimension",
    advSearchYearOfPub: "Year of publication",
    advSearchPrimaryDac: "Primary DAC Code",
    advSearchSecondaryDac: "Secondary DAC Code",
    advSearchCrsDac: "CRS Voluntary DAC Code",
    advSearchUnSdg: "UN_SDG",
    advSearchPriDataset: "Primary Dataset Availability",
    advSearchInterventions: "Interventions",
    advSearchOutcomes: "Outcomes",
    advSearchRegistration: "Pre Registration",
    advSearchPlaceholder: "Title:(Human Rights) AND 3ie Product:(Impact Evaluation) AND Country:(India) OR Country:(China)",
    advSearchQueryPlaceholder: "Query",
    filterResultsHeading: "Filter Results",
    tooltipYearOfPub: "Year of publication indicates when the research product was published.",
    tooltipFcvStatus: "Fragility and conflict-affected status of the country in which a study was conducted is specified according to World Bank Group's list of fragile and conflict-affected situations (FCS).",
    tooltipFundedBy: "Information is provided on whether the research was funded by the International Initiative for Impact Evaluation (3ie), or by another funder.",
    tooltipDatasetAvail: "Indicates whether the data analysed in a study has been made publicly available by the authors.",
    tooltipDacCodes: "This is the primary code for",
    tooltipDacCodesSuffix: ". Secondary, CRS, Voluntary codes are available using Advanced search.",
    tooltipRegion: "Geographic regions (continents) are specified according to World Bank Group's country classification list.",
    tooltipProducedBy3ie: "Restricts results to research produced by 3ie.",
    tooltipEquityFocus: "Equity focus indicates whether gender or equity is considered in a study. And if yes, then how exactly? E.g. equity sensitive methodology, sub-group analysis. More informattion in the ",
    tooltipEquityFocusEnd: " section",
    tooltipOutcome: "Standardized classification of outcomes measured. Explore the taxonomy ",
    tooltipOutcomeEnd: ".",
    tooltipEquityDim: "Equity dimension indicates which dimensions of gender and/or equity are addressed in a study. E.g. sex, socioeconomic status. More informattion in the ",
    tooltipEquityDimEnd: " section",
    tooltipThemes: "Themes are classified according to World Bank Group's Theme",
    tooltipThemesEnd: "and definitions (Revised July 1, 2016)",
    tooltipInterventions: "Standardized classification of the interventions evaluated. Explore the taxonomy ",
    sortByHeading: "Sort By",
    filterBy: "Filter by",
    tooltipPrint: "Select one or more records to print",
    tooltipExportRis: "Export results (ris)",
    tooltipExportXlsx: "Export results (xlsx)",

    continueBtn: "Continue",
    alertExportLimitMsg1Filter: "When intervention or outcome filters are applied export is limited to",
    alertExportLimitMsg2: "records.",
    alertExportLimitMsg1Tech: "We are sorry but due to technical limitations it is only feasible to export",
    alertExportLimitMsg4: "records at a time.",
    tooltipSectors: "Sectors are classified according to World Bank Group's Sector",
    tooltipSectorsEnd: "and definitions (Revised July 1, 2016)",
    tooltipCountry: "Country names are specified according to World Bank Group's country classification list.",
    tooltipRegistration: "Indicates whether the study has been registered.",
    tooltipEvalMethod: "Impact evaluation method used in the study. Please note that applying any value will filter out any systematic reviews.",
    tooltipConfidenceRating: "You can filter systematic reviews by confidence rating, which reflects how confident we are in a review’s findings, based on a detailed methodological appraisal.",
    tooltipStudyType: "Type of research product indicates whether this is an impact evaluation, systematic review or evidence gap map (as defined in the ",
    tooltipStudyTypeEnd: " section)",
    countries: "Countries",
    secondaryDacCode: "Secondary DAC Code",
    crsVoluntaryDacCode: "CRS Voluntary DAC Code",
    location: "Location",
    clickToExpandGeo: "Click to expand geographic info",
    clickToCollapseGeo: "Click to collapse geographic info",


    evaluationDesign: "Evaluation design",
    mixedMethod: "Mixed method",
    unitOfObservation: "Unit of observation",
    clickToExpandMethods: "Click to expand methods info",
    clickToCollapseMethods: "Click to collapse methods info",
    reviewType: "Review type",
    quantitativeMethod: "Quantitative method",
    qualitativeMethod: "Qualitative method",
    overallStudies: "Overall studies",
    highQuality: "High quality",
    mediumQuality: "Medium quality",
    clickToExpandProgram: "Click to expand program and agency info",
    clickToCollapseProgram: "Click to collapse program and agency info",
    primaryDatasetFormat: "Primary Dataset Format",
    secondaryDatasetName: "Secondary Dataset Name",
    additionalDatasetInfo: "Additional Dataset Information",
    analysisCodeFormat: "Analysis Code Format",
    studyMaterialsList: "Study Materials List",
    ethicsApproval: "Ethics Approval",
    clickToExpandTransp: "Click to expand transparency info",
    clickToCollapseTransp: "Click to collapse transparency info",
    sectorInformation: "Sector Information",
    methodologicalInformation: "Methodological Information",
    programFundingImplementation: "Program, Funding, and Implementation",
    transparency: "Transparency",
    subSector: "Sub-sector",
    seeEquityDesc: "See Equity Description",
    additionalMethod1: "Additional method 1",
    additionalMethod2: "Additional method 2",
    protocolPreAnalysisPlan: "Protocol Pre-Analysis Plan",
    abstractHeading: "Abstract",
    publicationDetails: "Publication Details",
    doi: "DOI",
    language: "Language",
    openAccess: "Open access",
    confidenceIndicator: "Confidence indicator",
    lowConfidence: "LOW CONFIDENCE",
    mediumConfidence: "MEDIUM CONFIDENCE",
    highConfidence: "HIGH CONFIDENCE",

    clickToExpandAuthorInfo: "Click to expand author info",
    clickToCollapseAuthorInfo: "Click to collapse author info",
    clickToExpandInterventionInfo: "Click to expand intervention info",
    clickToCollapseInterventionInfo: "Click to collapse intervention info",
    clickToExpandOutcomeInfo: "Click to expand outcome info",
    clickToCollapseOutcomeInfo: "Click to collapse outcome info",
    sectorLabel: "Sector",
    equityDimension: "Equity dimension",
    details: "Details",
    seeAllStudiesIntervention: "See all studies for this intervention",
    seeAllStudiesOutcome: "See all studies for this outcome",
    definition: "Definition",
    copied: "Copied.",
    interventionPrefix: "Intervention",
    interventionSingle: "Intervention:",
    otherStudies: "Other Studies",
  },
  ar: {
    menu: "القائمة",
    blogs: "المدونات",
    events: "الفعاليات",
    jobs: "الوظائف",
    careers: "الوظائف",
    media: "الإعلام",
    newsletter: "النشرة الإخبارية",
    resources: "الموارد",
    donate: "تبرع",
    login: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    myAccount: "حسابي",
    savedSearches: "عمليات البحث المحفوظة",
    recentSearches: "عمليات البحث الأخيرة",
    bookmarks: "الإشارات المرجعية",
    settings: "الإعدادات",
    admin: "المشرف",
    logout: "تسجيل الخروج",
    about: "عن المنظمة",
    whatWeOffer: "ما نقدمه",
    ourWork: "عملنا",
    team: "الفريق",
    supporters: "الداعمون",
    members: "الأعضاء",
    atAGlance: "لمحة سريعة",
    rcc: "مركز تكليف البحوث",
    governance: "الحوكمة",
    partners: "الشركاء",
    policies: "السياسات والتقارير المؤسسية",
    contactUs: "اتصل بنا",
    services: "الانشطة",
    research: "الأبحاث",
    evidenceHub: "مركز الأدلة",
    dep: "بوابة أدلة التنمية",
    egm: "خرائط فجوة الأدلة",
    eis: "ملخصات تأثير الأدلة",
    isd: "لوحة تحكم قصص التأثير",
    jde: "مجلة فعالية التنمية",
    publications: "المنشورات",
    replication: "دراسات التكرار",
    impact: "التأثير",
    termsOfUse: "شروط الاستخدام",
    privacyPolicy: "سياسة الخصوصية",
    copyright: "حقوق النشر ©",
    allRightsReserved: "المبادرة الدولية لتقييم الأثر (3ie) | جميع الحقوق محفوظة | ",
    aboutUsText: "نحن منظمة غير ربحية مدفوعة بمهمة مكرسة لاستخدام الأدلة لتغيير حياة الناس. نحن نتعاون مع الحكومات والمؤسسات والمنظمات غير الحكومية ومنظمات التنمية والبحوث في جميع أنحاء العالم.",
    exploreAboutUs: "استكشف عن المنظمة",
    whatWeOfferText: "نحن ندعم الحكومات وشركاء التنمية لتوليد واستخدام أدلة دقيقة تفيد في تحسين السياسات والبرامج والاستثمارات. يشمل عملنا دورة صنع القرار بأكملها، مما يساعد في تحديد ما ينجح، ولماذا ينجح، وكيفية تحسين النتائج.",
    exploreWhatWeOffer: "استكشف ما نقدمه",
    theoryOfChange: "تطوير نظرية التغيير",
    evidenceSynthesis: "تجميع الأدلة",
    impactEvalScoping: "تحديد نطاق وتصميم تقييمات الأثر",
    researchGrantsAdmin: "إدارة المنح البحثية",
    impactEvaluation: "تقييم الأثر",
    trainingInitiatives: "مبادرات التدريب",
    treHelpdesk: "مكتب المساعدة للشفافية والبحوث والأخلاقيات",
    ourWorkText: "تغطي محفظتنا المتنوعة من الأدلة إلى السياسات جميع قطاعات ومناطق التنمية الرئيسية وتمثل حجم وعمق البرامج والمبادرات العالمية لـ 3ie.",
    exploreOurWork: "استكشف عملنا",
    education: "التعليم",
    foodSystemsEgm: "خريطة فجوة وأدلة النظم الغذائية والتغذية",
    climateChange: "التخفيف من آثار تغير المناخ والتكيف معها",
    ruralIndiaLivelihoods: "مشروع سبل العيش الريفية في الهند",
    peacebuilding: "بناء السلام",
    genderEmpowerment: "التمكين والمساواة بين الجنسين",
    innovationsData: "الابتكارات في البيانات لتقييم الأثر",
    wacie: "WACIE",
    globalEvidenceCommitment: "الالتزام العالمي بالأدلة: تعزيز استخدام الأدلة الدقيقة",
    evidenceHubTextDesc: "نجعل أدلة التنمية عالية الجودة في متناول الجمهور من خلال قواعد البيانات والمجلات والمستودعات الرئيسية، والتي تشمل الدراسات التي أنتجتها 3ie وما وراءها.",
    exploreEvidenceHub: "استكشف مركز الأدلة",
    welcomeTitle: "خرائط الفجوات في الادلة والبراهين العلمية",
    welcomeDesc: "بوابة أدلة التنمية هي مكتبة علمية واسعة ومتنامية للأدلة العلمية الدقيقة والصارمة وتوثق ما ينجح في التنمية الدولية. تحتوي المكتبة على تقييمات أثر صارمة علميا عالية الجودة، ومراجعات منهجية، وخرائط فجوة الأدلة. وتعد هذه المكتبة المورد الأكثر شمولاً لهذا النوع من الأدلة العلمية من البلدان المنخفضة والمتوسطة الدخل. نحن نحافظ على هذه البوابة المعرفية كمنفعة عامة عالمية ونضمن تحديثها بشكل متكرر ونحن ملتزمون بإبقائها محدثة على هذا النحو",
    aboutDep: "حول بوابة أدلة التنمية",
    seeWhatsNew: "شاهد ما هو جديد",
    latestAnnouncement: "آخر إعلان: ",
    ier: "سجلات تقييم الأثر",
    srr: "سجلات المراجعات المنهجية",
    evidenceText: "خرائط الفجوات المعرفية في الأدلة العلمية",
    gapMaps: " ",
    exploreBySector: "استكشف حسب القطاع",
    ourDonors: "شركاؤنا الرئيسيون/المانحون",
    popularSearches: "عمليات البحث الشائعة",
    moreEvidence: "مزيد من الأدلة من عملنا",
    mostRecentSearches: "أحدث عمليات البحث",
    seeAll: "عرض الكل",
    noRecentSearches: "لم يتم العثور على بيانات عمليات بحث حديثة.",
    noSavedSearches: "لم يتم العثور على بيانات عمليات بحث محفوظة.",
    previousSearches: "عمليات البحث السابقة",
    noPreviousSearches: "لم يتم العثور على بيانات عمليات بحث سابقة.",
    backToSearch: "العودة إلى البحث",
    publishedOn: "تم النشر في",
    whatsNew: "ما الجديد",
    back: "العودة",
    decisionTree: "شجرة قرار بوابة الأدلة التنموية",
    taxonomyExplorer: "مستكشف التصنيف",
    backToEvidencePortal: "العودة إلى بوابة الأدلة",
    taxonomyIntroPart1: "لتسهيل العثور على الأدلة ذات الصلة، قامت 3ie بتوثيق التدخلات التي تم تقييمها والنتائج التي تم قياسها في آلاف الدراسات في بوابة الأدلة الخاصة بنا. يتم تنظيم هذه التدخلات والنتائج في تصنيف هرمي. لمعرفة المزيد حول التصنيف انقر",
    here: "هنا",
    taxonomyIntroPart2: "استخدم مستكشف التصنيف لتحديد التدخلات / النتائج التي تهمك، ثم استخدمها للبحث أو تصفية الدراسات",
    backOnThePortal: "مرة أخرى على البوابة.",
    enterKeyword: "يرجى إدخال كلمة رئيسية! ",
    checkInterventionOutcome: "يرجى التحقق من خيار واحد على الأقل من التدخل والنتيجة! ",
    searchBtn: "بحث",
    resetBtn: "إعادة ضبط",
    interventionsCheckbox: "التدخلات *",
    outcomesCheckbox: "النتائج *",
    definitionsCheckbox: "التعريفات (اختياري)",
    checkAsterisk: "يرجى التحقق من خيار واحد على الأقل من الحقول المميزة بعلامة النجمة (",
    interventionsLabel: "التدخلات",
    outcomesLabel: "النتائج",
    selectSectors: "تحديد القطاعات",
    searchPlaceholder: "بحث",
    seeAllInterventions: "شاهد جميع الدراسات بهذا التدخل",
    seeAllOutcomes: "شاهد جميع الدراسات بهذه النتيجة",
    backToTaxonomySearch: "العودة إلى بحث التصنيف",
    searchResultsTitle: "نتائج البحث | 3ie",
    alertsSentToEmail: "سيتم إرسال التنبيهات إلى البريد الإلكتروني المرفق بحسابك.",
    createAccountToAlert: "قم بإنشاء حساب لإنشاء تنبيه بحث",
    searchSaved: "تم حفظ هذا البحث.",
    createAccountToSave: "قم بإنشاء حساب لحفظ هذا البحث",
    bookmarkSaved: "تم حفظ هذه العلامة المرجعية.",
    createAccountToBookmark: "قم بإنشاء حساب لوضع إشارة مرجعية على هذا السجل",
    bookmarkRemoved: "تمت إزالة العلامة المرجعية بنجاح.",
    createAccountToDeleteBookmark: "قم بإنشاء حساب لحذف هذا السجل المرجعي",
    okay: "حسنا",
    success: "نجاح!",
    noResultsFor: "لا توجد نتائج لـ ",
    hereAreSomeTips: "إليك بعض النصائح:",
    checkSpellingMistakes: "تحقق من الأخطاء الإملائية",
    reduceKeywords: "قلل عدد الكلمات الرئيسية المستخدمة أو جرب عبارة بحث أوسع",
    tryAlternativeSearches: "جرب عمليات البحث البديلة أو أقسام الفلاتر المقترحة أدناه",
    orMaybeWeCanHelp: "أو ربما يمكننا المساعدة",
    alternativeSearches: "عمليات البحث البديلة",
    noAlternativeSearches: "لم يتم العثور على عمليات بحث بديلة",
    geographicInformation: "المعلومات الجغرافية",
    districtName: "اسم المنطقة: ",
    stateProvinceName: "اسم الولاية / المقاطعة: ",
    cityTown: "المدينة/البلدة: ",
    keywords: "الكلمات الدالة: ",
    expandSectorInfo: "انقر لتوسيع معلومات القطاع",
    collapseSectorInfo: "انقر لطي معلومات القطاع",
    projectName: "اسم المشروع: ",
    implementationAgency: "وكالة التنفيذ: ",
    programFundingAgency: "وكالة تمويل البرنامج: ",
    researchFundingAgency: "وكالة تمويل البحوث: ",
    headlineFindings: "أهم النتائج",
    evidenceBase: "قاعدة الأدلة",
    implicationsPolicyPractice: "الآثار المترتبة على السياسات والممارسة",
    implicationsFurtherResearch: "الآثار المترتبة على مزيد من البحوث",
    mainFindings: "النتائج الرئيسية",
    grantholdingInstitution: "المؤسسة الحاصلة على المنحة",
    evidenceProgramme: "برنامج الأدلة",
    synopsis: "ملخص",
    context: "سياق",
    researchQuestions: "أسئلة البحث",
    methodologySummary: "ملخص المنهجية",
    methodology: "المنهجية",
    instancesEvidenceUse: "حالات استخدام الأدلة",
    background: "خلفية",
    researchObjectives: "أهداف البحث",
    findings: "النتائج",
    qualityAssessment: "تقييم الجودة",
    fundedBy3ie: "بتمويل من 3ie",
    bookmark: "إشارة مرجعية",
    systematicReviews: "المراجعات المنهجية",
    impactEvaluations: "تقييمات التأثير",
    status: "الحالة",
    countryUppercase: "بلد",
    readMore: "اقرأ المزيد",
    printThisPage: "اطبع هذه الصفحة",
    goToMapUrl: "انتقل إلى رابط الخريطة",
    goToPublicationUrl: "انتقل إلى رابط المنشور",
    goToSource: "انتقل إلى المصدر",
    lookForOpenVersion: "ابحث عن نسخة مفتوحة",
    goToDataset: "انتقل إلى مجموعة البيانات",
    goToRegistration: "انتقل إلى التسجيل",
    clearFilters: "مسح عوامل التصفية",
    apply: "تطبيق",
    taxonomy: "التصنيف",
    aboutTheRepository: "حول المستودع",
    oecdDacClassification: "تصنيف قطاع OECD DAC",
    unSdg2030: "أهداف التنمية المستدامة للأمم المتحدة 2030",
    noFiltersFor: "لا توجد مرشحات لـ ",
    of: "من",
    resultsLabel: "النتائج",
    similarSearches: "عمليات بحث مماثلة:",
    systematicReviewsTag: "المراجعات المنهجية",
    impactEvaluationsTag: "تقييمات التأثير",
    evidenceGapMapsTag: "خرائط فجوة الأدلة",
    threeieFundingTag: "تمويل 3ie",
    otherFundingSourcesTag: "مصادر التمويل الأخرى",
    yesTag: "نعم",
    noTag: "لا",
    saveSearch: "حفظ البحث",
    createNotification: "إنشاء إشعار",
    selectAllOnPage: "تحديد الكل في الصفحة:",
    selectAll: "تحديد الكل:",
    records: "السجلات",
    resultsPerPage: "النتائج لكل صفحة",
    mostRelevant: "الأكثر صلة",
    mostRecent: "الأحدث",
    mostPopular: "الأكثر شعبية",
    sortByLabel: "ترتيب حسب",
    notSureWhereToStart: "لست متأكداً من أين تبدأ؟ جرب",
    searchGuideNew: "جديد",
    searchGuidanceTool: "أداة توجيه البحث",
    advancedSearchTitle: "البحث المتقدم",
    taxonomyOf: "تصنيف",
    interventionsAndOutcomes: "التدخلات والنتائج",
    taxonomyTooltipText: "قامت 3ie بتوثيق التدخلات التي تم تقييمها والنتائج التي تم قياسها في آلاف الدراسات في بوابة الأدلة الخاصة بنا. يتم تنظيم هذه التدخلات والنتائج في تصنيف هرمي لتسهيل العثور على الأدلة ذات الصلة. استخدم مستكشف التصنيف لتحديد التدخلات / النتائج التي تهمك، ثم استخدمها للبحث أو تصفية الدراسات على البوابة.",
    addAnotherSection: "+ أضف قسمًا آخر",
    clearBtn: "مسح",
    helpBtn: "مساعدة",
    provideAdvancedSearchQuery: "يرجى تقديم استعلام البحث المتقدم.",
    advFirstTimeDialogText: "هل هذه المرة الأولى التي تستخدم فيها البحث المتقدم؟ هذه الميزة قوية جدًا ولكن يجب استخدامها بطريقة معينة لإرجاع النتائج المتوقعة. نشجعك على مراجعة الوثائق بالنقر فوق زر \"مساعدة\" أسفل شريط البحث.",
    searchPhrasePlaceholder: "ابحث عن عبارة مثل \"التحويلات النقدية\"",
    aboutBtn: "حول",
    orText: "أو",
    exploreAllRecordsUsingFilters: "استكشف جميع السجلات باستخدام عوامل التصفية",
    selectOption: "حدد خياراً",
    impactEvaluationFilter: "تقييم الأثر",
    systematicReviewFilter: "المراجعة المنهجية",
    evidenceGapMapFilter: "خريطة فجوة الأدلة",
    sectorAgriculture: "الزراعة وصيد الأسماك والغابات",
    sectorEducation: "التعليم",
    sectorEnergy: "الطاقة والصناعات الاستخراجية",
    sectorFinance: "القطاع المالي",
    sectorHealth: "الصحة",
    sectorSocialProtection: "الحماية الاجتماعية",
    sectorIndustryTrade: "الصناعة والتجارة والخدمات",
    sectorInformationCommunications: "تكنولوجيا المعلومات والاتصالات",
    sectorPublicAdministration: "الإدارة العامة",
    sectorTransportation: "المواصلات",
    sectorWaterSanitation: "المياه والصرف الصحي وإدارة النفايات",
    noteAboutFilters: "ملاحظة حول استخدام عوامل التصفية",
    filterNoteP1: "تعتمد عوامل التصفية الموجودة على هذا الموقع على المعلومات التي نلتقطها حول كل دراسة، والتي نقوم بفهرستها باستخدام عملية تشفير مكثفة العمالة. نخطط في النهاية لتشفير جميع المعلومات لكل دراسة، ولكن محدودية الموارد تعني أننا في بعض الأحيان لا يمكننا التقاط جميع المعلومات لكل دراسة على الفور. ونتيجة لذلك، تفتقر بعض الدراسات إلى بعض المعلومات المستخدمة لدفع عوامل التصفية.",
    filterNoteP1Bold: "عند تطبيق عامل تصفية، قد تقوم بتصفية الدراسات التي تهمك، ولكنها لم يتم تشفيرها بالكامل بعد.",
    filterNoteP2: "تم تشفير جميع الدراسات من عام 2016 وما قبله بالكامل، لذلك لا تخاطر بتصفية أي دراسات ما قبل عام 2017. بالإضافة إلى ذلك، تم تشفير جميع الدراسات لنوع الدراسة والقطاع والمنطقة والبلد والهشاشة والصراع وسنة النشر، لذلك ستسترد عوامل التصفية هذه دائمًا جميع الدراسات ذات الصلة. لكن تطبيق عوامل التصفية الأخرى قد يترك بعض الدراسات الحديثة.",
    filterNoteP3: "لضمان عدم تصفية الدراسات ذات الأهمية، يمكنك الاعتماد على وظيفة البحث الأساسية، والتي ستجد جميع الدراسات التي تحتوي على مصطلحات البحث في العنوان أو الملخص.",
    filterNoteP4: "يمكنك مساعدتنا في الحفاظ على تحديث بوابة الأدلة، مع معلومات كاملة عن كل دراسة، من خلال",
    makingADonation: "تقديم تبرع.",
    decisionDialogIntro: "تحتوي بوابة أدلة التنمية على ثروة من الأدلة حول ما ينجح في التنمية العالمية. ولكن العثور على ما تحتاجه في قاعدة بيانات واسعة مثل DEP ليس دائماً بالأمر السهل. لمساعدتك في العثور على الأدلة الأكثر فائدة، قمنا بإنشاء أداة ترشدك خلال عملية البحث في DEP، خطوة بخطوة.",
    exploreMore: "اكتشف المزيد", surveyModalHeading: "ساعدنا في تحسين تجربتك!",
    surveyModalIntroText1: "أجب عن سؤال واحد سريع أدناه أو",
    surveyTakeFullSurvey: "شارك في الاستطلاع الكامل",
    surveyModalIntroText2: "لمشاركة المزيد من الملاحظات.",
    otherLabel: "أخرى:",
    pleaseSpecify: "يرجى التحديد",
    closeButton: "إغلاق",
    submitFeedbackButton: "إرسال ملاحظاتي",
    dontShowAgain: "لا تظهر هذا مرة أخرى",
    successModalHeading: "شكرًا لك على وقتك وملاحظاتك!",
    successModalIntroTextSuccess: "نحن نقدر لك تخصيص لحظة لمشاركة ملاحظاتك. ستساعدنا ردودك على تحسين تجربتك في بوابة أدلة التنمية الخاصة بـ 3ie.",
    successModalIntroTextError: "نأسف، ولكن لم نتمكن من إكمال الاستطلاع بسبب مشكلة فنية. يرجى المحاولة مرة أخرى لاحقًا.",
    fillOutCompleteSurvey: "املأ الاستطلاع الكامل ←",
    q1_question: "ما مدى فائدة بوابة أدلة التنمية (DEP) لعملك، على مقياس من 1 إلى 5؟",
    q2_question: "لماذا تبحث عن الأدلة اليوم؟ أبحث لـ (يرجى تحديد كل ما ينطبق)",
    q2_opt1: "البحث عن دراسات لتضمينها في مراجعة أدبيات / مراجعة منهجية",
    q2_opt2: "توجيه تصميم دراسة تقييم",
    q2_opt3: "جمع رؤى مفيدة لتكليف أبحاث جديدة",
    q2_opt4: "إرشاد القرارات حول البرامج التي يجب تنفيذها أو كيفية تنفيذها",
    q2_opt5: "لإعلام مقترح",
    q3_question: "كم مرة تستخدم بوابة أدلة التنمية؟",
    q3_opt1: "يومياً",
    q3_opt2: "أسبوعياً",
    q3_opt3: "شهرياً",
    q3_opt4: "نادراً",
    q3_opt5: "أستخدمها لأول مرة اليوم",
    q4_question: "أي من هذه تعتقد أنه سيحسن من فائدة وتجربة المستخدم لبوابة أدلة التنمية (DEP)؟ (يرجى تحديد كل ما ينطبق)",
    q4_opt1: "قدرات بحث وتصفية أفضل",
    q4_opt2: "روبوت محادثة للاستعلام عن البيانات الوصفية للدراسة (مثل: كم عدد الدراسات التي أجريت في بلد معين، كم عدد الدراسات التي استخدمت طريقة معينة، إلخ.)",
    q4_opt3: "روبوت محادثة للاستعلام عن نتائج الدراسة (مثل: ماذا تقول الدراسات حول فعالية تدخل X، إلخ.)",
    q4_opt4: "تصورات بيانات تفاعلية / رسوم بيانية حول الأدلة لمختلف القطاعات، المناطق، إلخ.",
    q4_opt5: "سهولة الاستخدام على الهاتف المحمول",
    q4_opt6: "أداء الصفحة (سرعة التحميل)",
    q4_opt7: "واجهة بحث بلغات أخرى",
    q5_question: "ما هو انتماؤك المؤسسي الحالي؟ يرجى تحديد كل ما ينطبق.",
    q5_opt1: "وكالة حكومية",
    q5_opt2: "مؤسسة أكاديمية",
    q5_opt3: "مركز أبحاث و/أو معهد أبحاث",
    q5_opt4: "جمعية تقييم - وطنية، إقليمية أو دولية",
    q5_opt5: "منظمة متعددة الأطراف",
    q5_opt6: "منظمة غير حكومية - دولية",
    q5_opt7: "منظمة غير حكومية - وطنية/محلية",
    q5_opt8: "شركة استشارية",
    q5_opt9: "وكالة مانحة",
    q5_opt10: "وسائط الإعلام",
    filterYearOfPub: "سنة النشر",
    filterFcvStatus: "الهشاشة والصراع",
    filterEvalMethod: "طريقة التقييم",
    filterSectors: "القطاعات",
    filterStudyType: "نوع الدراسة",
    filterFundedBy: "ممولة من قبل",
    filterDatasetAvail: "مجموعة البيانات متاحة",
    filterUnSdg: "الأهداف العالمية للأمم المتحدة",
    filterDacCodes: "رموز OECD DAC",
    filterEquityFocus: "التركيز على المساواة",
    filterOutcomes: "النتائج",
    filterRegion: "المنطقة",
    filterEquityDim: "أبعاد المساواة",
    filterProducedBy3ie: "أنتجت من قبل 3ie",
    filterCountry: "البلد",
    filterThemes: "المواضيع",
    filterRegistration: "التسجيل",
    filterInterventions: "التدخلات",
    advSearchTitle: "العنوان",
    advSearchAuthor: "المؤلف",
    advSearchKeywords: "الكلمات الدالة",
    advSearchAbstract: "الملخص",
    advSearchEvalDesign: "تصميم التقييم",
    advSearchEvalMethod: "طريقة التقييم",
    advSearchPubType: "نوع المنشور",
    advSearchStudyType: "نوع الدراسة",
    advSearchSector: "القطاع",
    advSearchRegion: "المنطقة",
    advSearchFundedBy: "ممول من",
    advSearchCountry: "البلد",
    advSearchPrimaryTheme: "الموضوع الرئيسي",
    advSearchEquityFocus: "التركيز على المساواة",
    advSearchEquityDimension: "أبعاد المساواة",
    advSearchYearOfPub: "سنة النشر",
    advSearchPrimaryDac: "رمز DAC الأساسي",
    advSearchSecondaryDac: "رمز DAC الثانوي",
    advSearchCrsDac: "رمز CRS Voluntary DAC",
    advSearchUnSdg: "أهداف التنمية المستدامة للأمم المتحدة",
    advSearchPriDataset: "توفر مجموعة البيانات الأساسية",
    advSearchInterventions: "التدخلات",
    advSearchOutcomes: "النتائج",
    advSearchRegistration: "التسجيل المسبق",
    advSearchPlaceholder: "العنوان:(حقوق الإنسان) AND نوع الدراسة:(تقييم الأثر) AND البلد:(الهند) OR البلد:(الصين)",
    advSearchQueryPlaceholder: "استعلام",
    filterResultsHeading: "تصفية النتائج",
    tooltipYearOfPub: "تشير سنة النشر إلى تاريخ نشر المنتج البحثي.",
    tooltipFcvStatus: "يتم تحديد حالة الهشاشة والتأثر بالنزاع للبلد الذي أجريت فيه الدراسة وفقًا لقائمة مجموعة البنك الدولي للحالات الهشة والمتأثرة بالنزاع (FCS).",
    tooltipFundedBy: "يتم توفير معلومات حول ما إذا كان البحث ممولاً من قبل المبادرة الدولية لتقييم الأثر (3ie)، أو من قبل ممول آخر.",
    tooltipDatasetAvail: "يشير إلى ما إذا كانت البيانات التي تم تحليلها في دراسة قد أتيحت للجمهور من قبل المؤلفين.",
    tooltipDacCodes: "هذا هو الرمز الأساسي لـ",
    tooltipDacCodesSuffix: ". الرموز الثانوية، CRS، والرموز التطوعية متاحة باستخدام البحث المتقدم.",
    tooltipRegion: "يتم تحديد المناطق الجغرافية (القارات) وفقًا لقائمة تصنيف الدول التابعة لمجموعة البنك الدولي.",
    tooltipProducedBy3ie: "يقيد النتائج على الأبحاث التي أنتجتها 3ie.",
    tooltipEquityFocus: "يشير التركيز على المساواة إلى ما إذا كان يتم أخذ النوع الاجتماعي أو المساواة في الاعتبار في الدراسة. وإذا كان الأمر كذلك، فكيف بالضبط؟ على سبيل المثال: منهجية حساسة للمساواة، تحليل مجموعة فرعية. مزيد من المعلومات في قسم ",
    tooltipEquityFocusEnd: ".",
    tooltipOutcome: "تصنيف موحد للنتائج المقاسة. استكشف التصنيف ",
    tooltipOutcomeEnd: ".",
    tooltipEquityDim: "يشير بُعد المساواة إلى أبعاد النوع الاجتماعي و/أو المساواة التي يتم تناولها في الدراسة. على سبيل المثال: الجنس، الحالة الاجتماعية والاقتصادية. مزيد من المعلومات في قسم ",
    tooltipEquityDimEnd: ".",
    tooltipThemes: "يتم تصنيف المواضيع وفقًا لموضوع مجموعة البنك الدولي",
    tooltipThemesEnd: "والتعاريف (المنقحة في 1 يوليو 2016)",
    tooltipInterventions: "تصنيف موحد للتدخلات التي تم تقييمها. استكشف التصنيف ",
    sortByHeading: "ترتيب حسب",
    filterBy: "تصفية بواسطة",
    tooltipPrint: "حدد سجلاً واحدًا أو أكثر للطباعة",
    tooltipExportRis: "تصدير النتائج (ris)",
    tooltipExportXlsx: "تصدير النتائج (xlsx)",

    continueBtn: "متابعة",
    alertExportLimitMsg1Filter: "عند تطبيق عوامل تصفية التدخل أو النتيجة، يقتصر التصدير على",
    alertExportLimitMsg2: "سجلات.",
    alertExportLimitMsg1Tech: "نأسف، ولكن نظرًا للقيود الفنية، لا يمكن تصدير سوى",
    alertExportLimitMsg4: "سجلات في المرة الواحدة.",
    tooltipSectors: "يتم تصنيف القطاعات وفقًا لقطاع مجموعة البنك الدولي",
    tooltipSectorsEnd: "والتعاريف (المنقحة في 1 يوليو 2016)",
    tooltipCountry: "يتم تحديد أسماء الدول وفقًا لقائمة تصنيف الدول التابعة لمجموعة البنك الدولي.",
    tooltipRegistration: "يشير إلى ما إذا كانت الدراسة قد تم تسجيلها.",
    tooltipEvalMethod: "طريقة تقييم الأثر المستخدمة في الدراسة. يرجى ملاحظة أن تطبيق أي قيمة سيؤدي إلى استبعاد أي مراجعات منهجية.",
    tooltipConfidenceRating: "يمكنك تصفية المراجعات المنهجية حسب تصنيف الثقة، والذي يعكس مدى ثقتنا في نتائج المراجعة، بناءً على تقييم منهجي مفصل.",
    tooltipStudyType: "يشير نوع المنتج البحثي إلى ما إذا كان هذا تقييمًا للأثر، أو مراجعة منهجية، أو خريطة فجوة الأدلة (كما هو محدد في قسم ",
    tooltipStudyTypeEnd: ")",
    countries: "البلدان",
    secondaryDacCode: "رمز لجنة المساعدة الإنمائية الثانوي",
    crsVoluntaryDacCode: "رمز نظام إعداد التقارير الدائنة التطوعي",
    location: "الموقع",
    clickToExpandGeo: "انقر لتوسيع المعلومات الجغرافية",
    clickToCollapseGeo: "انقر لطي المعلومات الجغرافية",

    evaluationDesign: "تصميم التقييم",
    mixedMethod: "الطريقة المختلطة",
    unitOfObservation: "وحدة الملاحظة",
    clickToExpandMethods: "انقر لتوسيع معلومات الأساليب",
    clickToCollapseMethods: "انقر لطي معلومات الأساليب",
    reviewType: "نوع المراجعة",
    quantitativeMethod: "الطريقة الكمية",
    qualitativeMethod: "الطريقة النوعية",
    overallStudies: "الدراسات الشاملة",
    highQuality: "جودة عالية",
    mediumQuality: "جودة متوسطة",
    clickToExpandProgram: "انقر لتوسيع معلومات البرنامج والوكالة",
    clickToCollapseProgram: "انقر لطي معلومات البرنامج والوكالة",
    primaryDatasetFormat: "تنسيق مجموعة البيانات الأساسية",
    secondaryDatasetName: "اسم مجموعة البيانات الثانوية",
    additionalDatasetInfo: "معلومات إضافية عن مجموعة البيانات",
    analysisCodeFormat: "تنسيق كود التحليل",
    studyMaterialsList: "قائمة مواد الدراسة",
    ethicsApproval: "الموافقة الأخلاقية",
    clickToExpandTransp: "انقر لتوسيع معلومات الشفافية",
    clickToCollapseTransp: "انقر لطي معلومات الشفافية",
    sectorInformation: "معلومات القطاع",
    methodologicalInformation: "معلومات منهجية",
    programFundingImplementation: "البرنامج والتمويل والتنفيذ",
    transparency: "الشفافية",
    subSector: "القطاع الفرعي",
    seeEquityDesc: "انظر وصف العدالة",
    additionalMethod1: "طريقة إضافية 1",
    additionalMethod2: "طريقة إضافية 2",
    protocolPreAnalysisPlan: "بروتوكول خطة التحليل المسبق",
    abstractHeading: "ملخص",
    publicationDetails: "تفاصيل النشر",
    doi: "معرف الوثيقة الرقمي",
    language: "اللغة",
    openAccess: "الوصول المفتوح",
    confidenceIndicator: "مؤشر الثقة",
    lowConfidence: "ثقة منخفضة",
    mediumConfidence: "ثقة متوسطة",
    highConfidence: "ثقة عالية",

    clickToExpandAuthorInfo: "انقر لتوسيع معلومات المؤلف",
    clickToCollapseAuthorInfo: "انقر لطي معلومات المؤلف",
    clickToExpandInterventionInfo: "انقر لتوسيع معلومات التدخل",
    clickToCollapseInterventionInfo: "انقر لطي معلومات التدخل",
    clickToExpandOutcomeInfo: "انقر لتوسيع معلومات النتائج",
    clickToCollapseOutcomeInfo: "انقر لطي معلومات النتائج",
    sectorLabel: "القطاع",
    equityDimension: "بُعد العدالة",
    details: "التفاصيل",
    seeAllStudiesIntervention: "انظر جميع الدراسات لهذا التدخل",
    seeAllStudiesOutcome: "انظر جميع الدراسات لهذه النتيجة",
    definition: "التعريف",
    copied: "تم النسخ.",
    interventionPrefix: "تدخل",
    interventionSingle: "تدخل:",
    otherStudies: "دراسات أخرى",
  }
};
